import { render, staticRenderFns } from "./pdf_view.vue?vue&type=template&id=5ba3a7c6&scoped=true"
import script from "./pdf_view.vue?vue&type=script&lang=ts"
export * from "./pdf_view.vue?vue&type=script&lang=ts"
import style0 from "./pdf_view.vue?vue&type=style&index=0&id=5ba3a7c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba3a7c6",
  null
  
)

export default component.exports